export const lobFormModes = Object.freeze(
  /** @type {const} */ ({
    CERTIFICATE: 'CERTIFICATE',
    MANAGER: 'MANAGER',
    VIEW: 'VIEW',
  })
);
